import React, { FC } from 'react';
import Image from 'next/image';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib';
import ErrorDark from '@shared/assets/images/cyber/errorDark.png';
const DataFetchingFailedError: FC = () => <Wrapper>
    <ImageWrapper>
      <Image src={ErrorDark} className="icon" alt="error404" height={120} width={120} />
    </ImageWrapper>
    <Title>
      Не удалось <br /> получить данные
    </Title>
    <Description>Повторите попытку позже</Description>
  </Wrapper>;
export default DataFetchingFailedError;
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "ww7ri4j",
  propsAsIs: false
});
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "i1nx02oi",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const Title = withTheme(/*#__PURE__*/styled('div')({
  name: "Title",
  class: "t1kafuvq",
  propsAsIs: false,
  vars: {
    "t1kafuvq-0": [_exp()],
    "t1kafuvq-1": [_exp2(), "px"],
    "t1kafuvq-2": [_exp3()],
    "t1kafuvq-3": [_exp4(), "px"],
    "t1kafuvq-4": [_exp5()]
  }
}));
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.tertiary;
const Description = withTheme(/*#__PURE__*/styled('div')({
  name: "Description",
  class: "d1ygjbp9",
  propsAsIs: false,
  vars: {
    "d1ygjbp9-0": [_exp6()],
    "d1ygjbp9-1": [_exp7(), "px"],
    "d1ygjbp9-2": [_exp8()],
    "d1ygjbp9-3": [_exp9(), "px"],
    "d1ygjbp9-4": [_exp0()]
  }
}));

require("./DataFetchingFailedError.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./DataFetchingFailedError.tsx");